<template>
  <div class="app-wrapper">
    <el-container>
      <el-header>
        <div class="title">
          <span class="toggle" @click="toggleChange">
            <i class="el-icon-s-fold"></i> </span>蓝韵心理咨询服务平台
        </div>
        <div class="flex">
          <div class="roleName">{{ userInfo.ROLE_NAME }}</div>
          <div>
            <el-dropdown>
              <span class="user-box">
                {{ userInfo.DISPLAY_NAME }}
                <img src="/static/images/icon-out.png" alt="" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <router-link to="/home">
                  <el-dropdown-item>首页</el-dropdown-item>
                </router-link>
                <el-dropdown-item divided>
                  <span @click="handleEditPwd">修改密码</span>
                </el-dropdown-item>
                <el-dropdown-item divided>
                  <span @click="loginOut">退出系统</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside :width="$store.state.isShow ? '250px' : '0'" ref="elSide">
          <div class="leftMenuContainer">
            <left-menu></left-menu>
          </div>
        </el-aside>
        <el-container>
          <el-main @click.native="mainClick">
            <div class="ly-container">
              <el-breadcrumb separator="/">
                <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
                <span>
                  <el-breadcrumb-item v-for="(item, index) in getBreakList" :key="index"><a :href="$route.path">{{
                    item.meta.title
                  }}</a></el-breadcrumb-item>
                </span>
              </el-breadcrumb>
              <router-view />
            </div>
          </el-main>
          <el-footer>
            <div class="main-footer">
              <p>
                <a target="_bank" href="http://www.beian.miit.gov.cn">蜀ICP备20012822号-4</a>
              </p>
              <p>
                  <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51010702042932" rel="noreferrer"
                    target="_blank">川公网安备51010702042932</a>
              </p>
              <p>
                <a href="http://www.bluerhyme.net/" target="_bank">四川蓝韵心理咨询服务有限公司</a>
              </p>
            </div>
          </el-footer>
        </el-container>
      </el-container>
    </el-container>
    <!-- 修改密码弹框 -->
    <el-dialog title="修改密码" width="750px" :visible.sync="ChangePwdFlag">
      <el-form :model="password" class="demo-form-inline" label-width="100px" :rules="Rules" ref="changepwdRef">
        <el-form-item label="原密码" prop="OldPassword">
          <el-input v-model="password.OldPassword" placeholder="请输入原密码" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="NewPassword">
          <el-input v-model="password.NewPassword" placeholder="请输入新密码" type="password"></el-input>
        </el-form-item>
        <el-form-item label="重复新密码" prop="repeatpwd">
          <el-input v-model="password.repeatpwd" placeholder="请输入新密码" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ChangePwdFlag = false">取消</el-button>
        <el-button type="primary" @click="Submit">修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import leftMenu from "./components/LeftMenu";
import topMenu from "./components/TopMenu";
import Breadcrumb from "@/components/Breadcrumb/index";
// import LeftMenu from "./components/LeftMenu.vue";
export default {
  components: {
    leftMenu,
    topMenu,
    Breadcrumb,
  },
  data() {
    return {
      // 侧边菜单栏显示/隐藏
      ChangePwdFlag: false,
      password: {
        OldPassword: "",
        NewPassword: "",
        repeatpwd: "",
      },
      userInfo: [],
      Rules: {
        OldPassword: [
          {
            required: true,
            message: "请输入原始密码",
            trigger: "blur",
          },
        ],
        NewPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
          },
        ],
        repeatpwd: [
          {
            required: true,
            message: "请重新输入新密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    getBreakList() {
      return this.$route.matched.filter((item) => item.meta.title);
    },
  },
  created() {
    this.userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
  },
  methods: {
    // 修改密码
    handleEditPwd() {
      this.ChangePwdFlag = true;
    },
    // 退出登录
    loginOut() {
      this.$confirm("是否退出登录", "提示?").then(() => {
        this.$router.push("/login");
      });
    },
    // 修改密码提交
    Submit() {
      if (this.password.NewPassword != this.password.repeatpwd) {
        this.$message({
          type: "error",
          message: "重复输入入的新密码不同！",
        });
        return false;
      }
      this.$refs.changepwdRef.validate((valid) => {
        if (valid) {
          // 提交
          this.ChangePwdFlag = false;
        }
      });
    },
    // 切换菜单栏
    toggleChange() {
      this.$store.commit("toggleChange");
    },
    // 点击内容区隐藏导航
    mainClick() {
      if (this.$store.state.isShow) {
        this.$store.commit("toggleChange");
      }
    },
  },
};
</script>
<style lang="less" scoped>
// 左侧导航栏过渡效果
.el-aside {
  transition: width 0.2s linear;
}

.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: rgba(249, 248, 253, 1);
  background-size: cover;

  .el-container {
    height: 100%;

    .title {
      font-size: 24px;

      .el-icon-s-fold {
        cursor: pointer;
        font-size: 26px;
        margin-right: 10px;
      }
    }

    .el-header {
      height: 70px !important;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0px 5px 15px rgba(179, 198, 252, 1);
      color: white;
      background-image: url("/static/images/home_top.png");
      background-size: cover;

      .header-left {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 100%;

        .toggle {
          cursor: pointer;

          .el-icon-s-fold {
            font-size: 30px;
          }
        }

        .name {
          margin-left: 20px;
          font-family: "微软雅黑 Regular", "微软雅黑";
          font-weight: 400;
          font-style: normal;
          font-size: 26px;
          color: #ffffff;
        }
      }

      .user-box {
        display: flex;
        align-items: center;
        color: white;
        font-size: 16px;
        cursor: pointer;

        img {
          width: 25px;
          height: 25px;
          margin-left: 10px;
        }
      }
    }

    .el-breadcrumb {
      margin: 20px 0 10px 0;
    }

    .el-aside {
      // height: 100%;
      overflow: auto;
      background: #283142;
      width: 250px;
      position: fixed;
      left: 0px;
      top: 70px;
      bottom: 0px;
      z-index: 999;

      .leftMenuContainer {
        height: 100%;
      }
    }

    .el-main {
      height: 100%;
      padding: 0 20px 0 20px !important;
      box-sizing: border-box;
    }

    .main-footer {
      //   height: 100%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      a {
        font-size: 13px;
        color: #999999;
        text-decoration: none;
      }
    }
  }
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: rgb(64, 158, 255);
  cursor: text;
}

.flex {
  display: flex;
  align-items: center;

  .roleName {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue